import { Box, Typography, Button, Link } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
const TIPS = [
  'Check the USB cable is plugged in firmly and try again.',
  'Unplug the sensor, wait a few seconds, plug it back in, then try again.',
  'Try a different USB cable or port, then try again.',
];
export default function ErrorPanel({ error, onRetry, onCancel }) {
  const tip = TIPS[Math.min((error?.attempt || 1) - 1, TIPS.length - 1)];
  return (
    <Box sx={{ textAlign: 'center', maxWidth: 440, mx: 'auto', py: 4 }}>
      <ErrorOutlineIcon sx={{ fontSize: 56, color: 'warning.main', mb: 2 }} />
      <Typography variant="h6" gutterBottom>That didn&apos;t work</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{error?.reason}</Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>{tip}</Typography>
      <Button variant="contained" onClick={onRetry} sx={{ mr: 1 }}>Try again</Button>
      <Button variant="text" onClick={onCancel}>Cancel</Button>
      {error?.fatal && (
        <Typography variant="body2" sx={{ mt: 2 }}>
          Still stuck? <Link href="mailto:support@vpsisensors.com">Contact support</Link>.
        </Typography>
      )}
    </Box>
  );
}
